// extracted by mini-css-extract-plugin
export default {"container":"ProductSizeItem_container__6kl3u","more":"ProductSizeItem_more__fyXZK"};